export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13800.7d07a011.jpg";